const Category = [
  'Household',
  'Beauty',
  'Accessories',
  'Women',
  'Baby',
  'Toys',
  'Teen',
  'Kids',
  'Men',
  'Crafts',
  'ArtPaintings',
  'Local Service',
];
export default Category;
